export default "__VITE_ASSET__CIcMvX0B__"